import { IMidroll } from 'LocalGluons/components/Player/Types';
import styled from 'styled-components';

const containerHeight = 6;

export const Midroll = styled.div.attrs<IMidroll>(({ fromLeft, length }: IMidroll) => ({
    style: {
        left: `${fromLeft}%`,
        width: length === 0 ? `${containerHeight}px` : `${length}%`,
    },
}))`
    position: absolute;
    height: 100%;
    background: #ffdb1c;
`;
